import { z } from 'zod'

import { TrieKeySchema } from '~/@entities/Curriculum'
import { ProblemLevelSchema } from '~/@entities/Problem'
import { SchoolTypeSchema } from '~/@entities/SchoolSystem'
import { SchoolTestTypeSchema } from '~/@entities/SchoolTest'

/***************** 자료 종류 *****************/
// 학교 기출 시험지와 그 밖의 자료(기타 자료)
export const PAPER_TYPE = ['CUSTOM_PAPER', 'SCHOOL_TEST_PAPER'] as const

export const PaperTypeSchema = z.enum(PAPER_TYPE)
export type PaperType = z.infer<typeof PaperTypeSchema>

/***************** 올린 자료 *****************/

/** 자료의 지면 한 장. boundingBoxes 는 지면에서 찾은 박스들의 좌표다 */
export const PaperPageSchema = z.object({
  index: z.number(),
  url: z.string(),
  boundingBoxes: z.array(z.array(z.number())),
})
export type PaperPage = z.infer<typeof PaperPageSchema>

/** 기출·기타 자료 지면의 박스 하나. url 은 지면에서 오려 낸 원본 박스 이미지다 */
export const PaperBoxSchema = z.object({
  index: z.number(),
  pageIndex: z.number(),
  url: z.string(),
  conceptId: z.number(),
  topicId: z.number().nullable(),
  subTopicId: z.number().nullable(),
  level: ProblemLevelSchema,
})
export type PaperBox = z.infer<typeof PaperBoxSchema>

/**
 * 선생님이 올린 기출·기타 자료 하나. 서버가 함께 내는 시행 학년·학기(enforcementGrade·enforcementSemester)·
 * 공유 범위(shareScope)·삭제 여부(deleteFlag)는 앱이 읽지 않아 받지 않는다.
 */
export const PaperSchema = z.object({
  id: z.number(),
  type: PaperTypeSchema,
  title: z.string(),
  gradeSemester: z.string(),
  schoolName: z.string().nullable(),
  schoolType: SchoolTypeSchema,
  schoolCode: z.string().nullable(),
  schoolTestYear: z.number().nullable(),
  schoolTestType: SchoolTestTypeSchema.nullable(),
  trieKey: TrieKeySchema,
  mixedContent: z.boolean().default(false),
  pdfUrl: z.string(),
  pages: z.array(PaperPageSchema),
  boxes: z.array(PaperBoxSchema),
  createDatetime: z.iso.datetime({ local: true }),
})
export type Paper = z.infer<typeof PaperSchema>

/** 나의DB 로 만든 자료. 박스마다 만든 나의DB 문항이 붙고, 앱은 그 문항으로 필터를 만들 id 만 읽는다 */
export const CreatedPaperSchema = PaperSchema.extend({
  myDbProblemDetails: z.array(z.object({ id: z.number() })),
})
export type CreatedPaper = z.infer<typeof CreatedPaperSchema>
